/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// add code by Aamir for industry cookies . do not change this #############################
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
// end industry cokkies code ########################################################


 function checkPasswordMatch() {
   var password = $("#CreatePassword").val();
   var confirmPassword = $("#confirmPassword").val();
   if($("#CreatePassword").val().length < 5 && $("#confirmPassword").val().length < 5){
        document.getElementById('re_errors3').innerHTML="*Passwords and Confirm password both should be greater then 5 Charecter !";
        document.getElementById('re_errors3').className += 'class_two';
        return false;
        }
   else if ( password != confirmPassword){
       document.getElementById('re_errors3').innerHTML="*Passwords do not match!";
       document.getElementById('re_errors3').className += 'class_two'; 
        return false;
        }
   else{
        $('#CreatePassword').css('border-color', '#ccc');
        $('#confirmPassword').css('border-color', '#ccc');
        document.getElementById('re_errors3').style.display = "none";
        return true;
       }
    }

 function allnumeric2(){
      var numbers = /^[0-9]+$/;
      var confirmPassword = $("#inquery_phone").val();
   
      if(numbers != confirmPassword){
      document.getElementById('errors7').innerHTML="*Please input numeric characters only!";
       return false; 
      }
   else{
        document.getElementById('errors7').style.display = "none";
        return true;
      }
   }

function qoutetext(){
  //var inputtext = $('quote_first_name').val();
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('quote_first_name').value)){
        document.getElementById('errors1').innerHTML= "Only Character allowed!";
        document.getElementById('errors1').className += 'class_two';
        return false; 
      }else{
    document.getElementById('errors1').style.display = "none"; 
    document.getElementById('errors').style.display = "none";
    $('#quote_first_name').css('border-color', '#ccc');     
    return true;
    }
}

function qoutetext2(){
  if(jQuery('#quote_last_name').val() == ''){
      document.getElementById('errors2').innerHTML= "This field cant be blank!";
      $('#quote_last_name').css('border-color', 'red');
      return false;
     }
 else if (!/^[a-zA-Z ]*$/g.test( document.getElementById('quote_last_name').value)){
        document.getElementById('errors2').innerHTML= "Only Character allowed!";
        document.getElementById('errors2').className += 'class_two';
        $('#quote_last_name').css('border-color', 'red');
        return false; 
   }else{
    document.getElementById('errors2').style.display = "none"; 
    $('#quote_last_name').css('border-color', '#ccc');  
    return true;
    }
}
function qoutetext3(){
  if( jQuery('#quote_company').val() != ''){
       $('#quote_company').css('border-color', '#ccc');
       return false;
      }
    }
function qouteemail(){
  //var inputtext = $('quote_first_name').val();
  if(jQuery('#quote_email').val() == ''){
      document.getElementById('errors2').innerHTML= "This field cant be blank!";
      $('#quote_email').css('border-color', 'red');
      return false;
     }
 else if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test( document.getElementById('quote_email').value)){
        document.getElementById('errors4').innerHTML= "Email type not valid!";
        document.getElementById('errors4').className += 'class_two';
        return false; 
   }else{
    document.getElementById('errors4').style.display = "none";
    $('#quote_email').css('border-color', '#ccc');    
    return true;
    }
}

 function allnumeric3(){
     /* var numbers = /^[0-9]+$/;
      var pnumber = $("#quote_phone_number").val();
      if(numbers != pnumber){
      document.getElementById('errors7').innerHTML="*Please input numeric only!";
      document.getElementById('errors7').innerHTML.className += 'class_two';  
       return false; 
      }
   else{
      document.getElementById('errors7').style.display = "none";
      }*/
      if($.isNumeric( $('#quote_phone_number').val()))
      {
      document.getElementById('errors7').style.display = "none";
      return true;  
      }
   else{
       document.getElementById('errors7').innerHTML="*Please input numeric only!";
       document.getElementById('errors7').innerHTML.className += 'class_two';  
       return false; 
      }
   }


function experttext1(){
  //var inputtext = $('quote_first_name').val();
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('order_first_name').value)){
        document.getElementById('errorse1').innerHTML= "Only Character allowed!";
        document.getElementById('errorse1').className += 'class_two';
        return false; 
      }else{
    document.getElementById('errorse1').style.display = "none"; 
    document.getElementById('errorse').style.display = "none";
    $('#order_first_name').css('border-color', '#ccc');    
    }
}

function experttext2(){
if(jQuery('#order_last_name').val() == ''){
      document.getElementById('errorse2').innerHTML= "This field cant be blank!";
      $('#order_last_name').css('border-color', 'red');
      return false;
     }
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('order_last_name').value)){
        document.getElementById('errorse2').innerHTML= "Only Character allowed!";
        document.getElementById('errorse2').className += 'class_two';
        return false; 
      }else{
    document.getElementById('errorse2').style.display = "none"; 
    document.getElementById('errorse1').style.display = "none";
    $('#order_last_name').css('border-color', '#ccc');     
    }
}

function expertemail(){
  //var inputtext = $('quote_first_name').val();
  if(jQuery('#order_email').val() == ''){
      document.getElementById('errorse3').innerHTML= "This field cant be blank!";
      $('#order_email').css('border-color', 'red');
      return false;
     }
 else if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test( document.getElementById('order_email').value)){
        document.getElementById('errorse3').innerHTML= "Email type not valid!";
        document.getElementById('errorse3').className += 'class_two';
        return false; 
   }else{
    document.getElementById('errorse3').style.display = "none";
    $('#order_email').css('border-color', '#ccc');    
    }
}

 function expertnumeric(){
      if($.isNumeric( $('#order_phone_number').val()))
      {
      document.getElementById('errorse4').style.display = "none";
      $('#order_phone_number').css('border-color', '#ccc');   
      }
   else{
       document.getElementById('errorse4').innerHTML="*Please input Number only!";
       document.getElementById('errorse4').innerHTML.className += 'class_two';  
       return false; 
      }
   }

function experttext(){
  if( jQuery('#expert_company').val() != ''){
       $('#expert_company').css('border-color', '#ccc');
       }
  else{
        $('#expert_company').css('border-color', 'red'); expert_company
        document.getElementById('expert_company').innerHTML="*This field cant be blank!";
        return false;
      }
    }

function serviestext1(){
  //var inputtext = $('quote_first_name').val();
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('service_first_name').value)){
        document.getElementById('ser_errors1').innerHTML= "Only Character allowed!";
        document.getElementById('ser_errors1').className += 'class_two';
        return false; 
   }else{
    document.getElementById('ser_errors').style.display = "none";
    document.getElementById('ser_errors1').style.display = "none"; 
    $('#service_first_name').css('border-color', '#ccc');  
    return true;
    }
}

function serviestext2(){
  if(jQuery('#service_last_name').val() == ''){
      document.getElementById('ser_errors2').innerHTML= "This field cant be blank!";
      $('#service_last_name').css('border-color', 'red');
      return false;
     }
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('service_last_name').value)){
        document.getElementById('ser_errors2').innerHTML= "Only Character allowed!";
        document.getElementById('ser_errors2').className += 'class_two';
        return false; 
   }else{
    document.getElementById('ser_errors2').style.display = "none"; 
    $('#service_last_name').css('border-color', '#ccc');  
    return true;
    }
}

function serviesemail(){
  //var inputtext = $('quote_first_name').val();
 if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test( document.getElementById('service_email').value)){
        document.getElementById('ser_errors3').innerHTML= "Email type not valid!";
        document.getElementById('ser_errors3').className += 'class_two';
        return false; 
   }else{
    document.getElementById('ser_errors3').style.display = "none";
    $('#service_email').css('border-color', '#ccc');    
    }
}

function serviestext(){
  if(jQuery('#service_company').val() != ''){
       $('#service_company').css('border-color', '#ccc');
       }
  else{
        $('#service_company').css('border-color', 'red'); 
        return false;
      }
    }


   
  function serviesnumeric(){
      if($.isNumeric( $('#service_phone').val()))
      {
      document.getElementById('ser_errors5').style.display = "none";
      $('#service_phone').css('border-color', '#ccc');   
      }
   else{
       document.getElementById('ser_errors5').innerHTML="*Please input Number only!";
       document.getElementById('ser_errors5').innerHTML.className += 'class_two';  
       return false; 
      }
   }


function inquerytext1(){
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('inquery_fname').value)){
        document.getElementById('inq_errors1').innerHTML= "Only Character allowed!";
        document.getElementById('inq_errors1').className += 'class_two';
        return false; 
   }else{
    document.getElementById('inq_errors').style.display = "none";
    document.getElementById('inq_errors1').style.display = "none"; 
    $('#inquery_fname').css('border-color', '#ccc');  
    }
}

function inquerytext2(){
  if(jQuery('#inquery_lname').val() == ''){
      document.getElementById('inq_errors2').innerHTML= "This field cant be blank!";
      $('#inquery_lname').css('border-color', 'red');
      return false;
     }
  else if (!/^[a-zA-Z ]*$/g.test( document.getElementById('inquery_lname').value)){
        document.getElementById('inq_errors2').innerHTML= "Only Character allowed!";
        document.getElementById('inq_errors2').className += 'class_two';
        return false; 
   }else{
    document.getElementById('inq_errors2').style.display = "none"; 
    $('#inquery_lname').css('border-color', '#ccc');  
    return true;
    }
}

function inqueryemail(){
  if(jQuery('#inquery_email').val() == ''){
      document.getElementById('inq_errors3').innerHTML= "This field cant be blank!";
      $('#inquery_email').css('border-color', 'red');
      return false;
     }
 else if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test( document.getElementById('inquery_email').value)){
        document.getElementById('inq_errors3').innerHTML= "Email type not valid!";
        document.getElementById('inq_errors3').className += 'class_two';
        return false; 
   }else{
    document.getElementById('inq_errors3').style.display = "none";
    $('#inquery_email').css('border-color', '#ccc');    
   }
}

function inquerytext(){
  if(jQuery('#inquery_organization').val() != ''){
       $('#inquery_organization').css('border-color', '#ccc');
       }
  else{
        $('#inquery_organization').css('border-color', 'red'); 
        return false;
      }
    }


   
    function inquerynumeric(){
      if($.isNumeric( $('#inquery_phone').val()))
      {
      document.getElementById('inq_errors7').style.display = "none";
      $('#inquery_phone').css('border-color', '#ccc');   
      }
   else{
       document.getElementById('inq_errors7').innerHTML="*Please input Number only!";
       document.getElementById('inq_errors7').innerHTML.className += 'class_two';  
       return false; 
      }
   }


function contacttext1(){
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('Contact_firstname').value)){
    document.getElementById('con_errors1').innerHTML= "Only Character allowed!";
    document.getElementById('con_errors1').className += 'class_two';
    return false; 
   }else{
    document.getElementById('con_errors').style.display = "none";
    document.getElementById('con_errors1').style.display = "none"; 
    $('#Contact_firstname').css('border-color', '#ccc');  
    }
}

function  contacttext2(){
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('contact_lastname').value)){
     document.getElementById('con_errors2').innerHTML= "Only Character allowed!";
     document.getElementById('con_errors2').className += 'class_two';
     return false; 
   }else{
    document.getElementById('con_errors2').style.display = "none"; 
    $('#contact_lastname').css('border-color', '#ccc');  
    return true;
    }
}

function contactemail(){
  if(jQuery('#contact_email').val() == ''){
     document.getElementById('con_errors3').innerHTML= "This input field can't be Empty!";
     return false;  
       } 
  else if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test( document.getElementById('contact_email').value)){
        document.getElementById('con_errors3').innerHTML= "Email type not valid!";
        document.getElementById('con_errors3').className += 'class_two';
        return false; 
   }else{
    document.getElementById('con_errors3').style.display = "none";
    $('#contact_email').css('border-color', '#ccc');    
   }
}

function contacttext(){
  if(jQuery('#contact_company').val() != ''){
       $('#contact_company').css('border-color', '#ccc');
       }
  else{
        $('#contact_company').css('border-color', 'red'); 
        return false;
      }
    }


   
function contactnumeric(){
      if($.isNumeric( $('#contact_mobile').val()))
      {
      document.getElementById('con_errors7').style.display = "none";
      $('#contact_mobile').css('border-color', '#ccc');   
      }
   else{
       document.getElementById('con_errors7').innerHTML="*Please input Number only!";
       document.getElementById('con_errors7').innerHTML.className += 'class_two';  
       return false; 
      }
   }



function registext1(){
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('FirstName').value)){
        document.getElementById('re_errors4').innerHTML= "Only Character allowed!";
        document.getElementById('re_errors4').className += 'class_two';
        $('.regis').css('border-color', 'red');
        return false; 
   }else{
    document.getElementById('re_errors4').style.display = "none"; 
    $('#FirstName').css('border-color', '#ccc');  
    }
}

function  registext2(){
  if (!/^[a-zA-Z ]*$/g.test( document.getElementById('LastName').value)){
    document.getElementById('re_errors5').innerHTML= "Only Character allowed!";
    document.getElementById('re_errors5').className += 'class_two';
    return false; 
   }else{
    document.getElementById('re_errors5').style.display = "none"; 
    $('#LastName').css('border-color', '#ccc');  
    return true;
    }
}

function regisemail(){
 if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test( document.getElementById('Email').value)){
    document.getElementById('re_errors1').innerHTML= "Email type not valid!";
    document.getElementById('re_errors1').className += 'class_two';
    return false; 
   }else{
    document.getElementById('re_errors').style.display = "none"; 
    document.getElementById('re_errors1').style.display = "none";
    $('#Email').css('border-color', '#ccc');    
   }
}

function registext(){
  if(jQuery('#customercompany').val() != ''){
       $('#customercompany').css('border-color', '#ccc');
       }
  else{
        $('#customercompany').css('border-color', 'red'); 
        return false;
      }
    }


   
function regisnumeric(){
      if($.isNumeric($('#customertelephone').val()))
      {
      document.getElementById('re_errors9').style.display = "none";
      $('#customertelephone').css('border-color', '#ccc');   
      }
   else{
       document.getElementById('re_errors9').innerHTML="*Please input Number only!";
       document.getElementById('re_errors9').innerHTML.className += 'class_two';  
       return false; 
      }
   }


$( document ).ready(function() {


  $('a[href^="#"]').click(function() {
      var target = $(this.hash);
      if (target.length == 0) target = $('a[id="' + this.hash.substr(1) + '"]');
      if (target.length == 0) target = $('html');
      $('html, body').animate({ scrollTop: target.offset().top-110 }, 1000);
      // return false;
  });



  $( '.scrollable' ).on( 'mousewheel DOMMouseScroll', function ( e ) {
    $(this).focus();
  });

  
  $(document).mouseup(function(e) 
   {
   if ($(".offerdetails.active").length > 0) 
    {  
    var container = $(".offerdetails.active .offertext");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.parent().parent().find(".offerdetails").removeClass('active');
        container.parent().parent().find(".offerdetails").addClass('inactive');
    }
   }  
        
   });
  
   $('.tableinject').prependTo( ".specs_data tbody" ).show();

   $('.offerclose').click(function(){
     $(this).parent().parent().removeClass('active');
     $(this).parent().parent().addClass('inactive');
   });
  
   $('.inactive .offerclick').click(function(){
     $(this).parent().parent().addClass('active');
     $(this).parent().addClass('close');
     $(this).parent().parent().removeClass('inactive');
   });


   $( "<span style='color:#FF0000; font-weight:bold;'>SALE</span>" ).appendTo(".snize-discounted-price");

 // $(this).scrollTop(0);

    $(document).on('click', 'a[href^=\\#]', function(e){
        e.preventDefault();
        var id = $(this).attr('href');
        var doofs = $('#main').offset().top;
        var off = $(id).offset().top;
        var offs = parseInt(off);
        $('html,body').animate({scrollTop: offs - doofs}, 500);
    });

  
  $('.faq-q').click(function(){
    $(this).parent().toggleClass('active');
  });

  $('.faq-button').click(function(){
    $('.faq-block').removeClass('active');
    $('.faq-button').removeClass('active');
    $('.'+$(this).attr('id')).addClass('active');
    $(this).addClass('active');
  });

  $('.closediv').click(function(){
    $(this).parent().hide();
    $(".shade").hide();
    $("body").removeClass('modal-open');
  });

   $('h3.stamped-review-header-title').replaceWith(function() {
     return $("<div style='font-weight:bold;'>", {
       class: this.className,
       html: $(this).html()
     });
   });

   $('#block-26a623e7-eacb-44c4-ad9b-94e3d3f84659, #block-template--15378339561627__3febc04c-4417-478d-91de-a7b11874ba85-1676631140a5c9534d-0, #block-template--15378339889307__74df0272-6b60-4f0d-a3c6-f907129739bf-1676631140a5c9534d-0').click(function(){
     window.location.href = "https://www.laballey.com/pages/meet-lab-alley-at-sxsw-2023";
   });

  
  $('.restricted.product-form__add-button').click(function(){
  // alert("This product will only be shipped to Schools, Universities, Laboratories, or Companies. If you are an individual ordering this product, it will not be shipped to you. It will be deleted from your order and the rest of the order will be shipped without your confirmation. A Statement of Use is required for purchase."); 
    alert("This product will only be shipped to Schools, Universities, Laboratories, or Companies. If you are an individual ordering this product, it will not be shipped to you. It will be deleted from your order and the rest of the order will be shipped without your confirmation."); 

  });

   $('.restricted_cus.product-form__add-button').click(function(){
   alert("This product is a restricted chemical and can only be shipped to a commercial/industrial address.  If you are an individual ordering this product, it will not be shipped to you. It will be deleted from your order and the rest of the order will be shipped without your confirmation.");   
  });

   if ($( document ).width() > 600) {
    var highestBox = 0;
        $('.thumbs .thumb').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.thumbs .thumb').height(highestBox);
  
  
    var highestBox = 0;
        $('#shopify-section-template--15378339594395__collection-list .collection-list .collection-item').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('#shopify-section-template--15378339594395__collection-list .collection-list .collection-item').height(highestBox);

    var highestBox = 0;
        $('.home-image-with-text.l1').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.home-image-with-text').height(highestBox);

    var highestBox = 0;
        $('.home-image-with-text.l2').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.home-image-with-text').height(highestBox); 
  }
 
  $('.product-form__cart-submit').click(function(){
 
  var prod_id = $(".product-template__container").attr('data-id');
  
  var arr = ['576712081467', '576712048699', '7275124818075', '576701399099', '7215487254683'];
  
  if (arr.indexOf(prod_id) != -1) { 
    
      if (confirm('Important: This product will only be shipped to Schools, Universities, Laboratories, or Companies. If you are an individual ordering this product, it will not be shipped to you. It will be deleted from your order and the rest of the order will be shipped without your confirmation. Would you like to add this product?')) {
          
      } else {
          return false; 
      }
  }  
      
 }); 
  
$('.landing').parent().parent().find('.breadcrumb').hide();
$('.landing').parent().parent().parent().find('#SiteNav > li:first-child').remove();

if ($('.replase-dash').length > 0) {
  var lines = $('.replase-dash').html().split("-");
  $('.replase-dash').html('');
  $.each(lines, function (i) {
     $('.replase-dash').append( "<li>"+lines[i]+"</li>" );
  });
} 

$('.cart__qty-input').on('change', function() {
  // $(this).parent().parent().find('.cart__update').trigger('click');
  // $(this).parent().parent().find('.cart__update').trigger('touchstart');
   var url = "/cart/change?line=" + $(this).data("line") + "&quantity=" + $(this).val();
    $.post( "test.php", { name: "John", time: "2pm" } );
  $(location).attr('href',url); 
  
   
   
});
   
 $('.show').click(function(){
   if ($(this).hasClass('showit')) {
     $('.pass').prop('type', 'text');
     $(this).addClass('hideit');
     $(this).removeClass('showit');
     $(this).html('Hide');
     $('.form__floating-label').hide();
   } else {
     $('.pass').prop('type', 'password');
     $(this).addClass('showit');
     $(this).removeClass('hideit');
     $(this).html('Show');
     $('.form__floating-label').show();
   }  
 });


// Sort the %
    var sortPercent = function (percentList) {
        percentList.sort(function (a, b) {
           return a.percent - b.percent;
        });
        return percentList;
    };
    
// Sort the Size
    var sortSize = function (sizeList) {
        sizeList.sort(function (a, b) {
           return a.size - b.size;
        });
        return sizeList;
    };

var percents = [];
// Get the option's label, value, price
    $('.Percentage option').each(function () {
    	var option = $(this);
      var percent = parseFloat(option.text());
      
        //var percent = getPercent(option.text());
        
        percents.push({
            label: option.html(),
            value: option.val(),
            selected: option.attr('selected'),
            percent: percent
        });
    });

var percentOptions = sortPercent(percents);
  
// create output HTML
var output = '';
for (var i = 0; i < percentOptions.length; i++) {
    var sel = percentOptions[i].selected;
    output += '<option '+sel+' value="' + percentOptions[i].value + '">' + percentOptions[i].label + '</option>';
}

// replace Percentage <select> with sorted options
$('#Percentage').html(output);	
    
var sizes = [];
    $('.Size option').each(function () {
    	var option = $(this);
      var size = parseFloat(option.text())*1;
      
        //var percent = getPercent(option.text());
        
        if(option.text().indexOf("kg") != -1){
            size = size * 1000;
        }
        
        if(option.text().indexOf("lb") != -1){
            size = size * 453.59237;
        }

        if(option.text().indexOf("Liter") != -1){
            size = size * 90000000;
        }
      
        if(option.text().indexOf("oz") != -1){
            size = size * 0.02957;
            size = size * 90000000;
        } 
        
        if(option.text().indexOf("ml") != -1){
            size = size / 1000;
            size = size * 90000000;
        } 
      
        
        if(option.text().indexOf("Gallon") != -1){
            size = size * 3.7854;
            size = size * 90000000;
        }
        
        if(option.text().indexOf("Pint") != -1){
            size = size * 0.4731765;
            size = size * 90000000;
        }

        if(option.text().indexOf("Quart") != -1){
            size = size * 0.946353;
            size = size * 90000000;
        }
        
        sizes.push({
            label: option.html(),
            value: option.val(),
            selected: option.attr('selected'),
            size: size
        });
    });
  
var sizeOptions = sortSize(sizes);

	
var output = '';
for (var i = 0; i < sizeOptions.length; i++) {
    var sel = sizeOptions[i].selected;
    output += '<option '+sel+' value="' + sizeOptions[i].value + '">' + sizeOptions[i].label + '</option>';
}

// replace Size <select> with sorted options
$('#Size').html(output);	
	
	
$("#apply-filters").click(function() {
	
	var $url = "";
	
	var selected = "";
	
	$('.filters .collectionselect').each(function(){
	 selected = $(this).children("option:selected").val();
     if (selected != "") {
        $('#params').text($('#params').text() + selected + '+'); 
     }
   });
	
   window.location = $('#base-url').text() + $('#params').text().slice(0, -1);   
});
	
  var variant = getUrlParameter('variant');	
  if (!variant) {
    id = $(".buttons").prop('id');
    $('.' + id).show();	
  } else {
    // $("#prodsize").children(variand).prop('selected', 'selected');
  } 

id = $(".ideal .button.active").prop('id');;
  $('.' + id).show();	
  // $('.product.' + id).first().find('input').click();
  $('.hideform').show();
 
  
$(".ideal .products_grouped .button").click(function() {

  $(".ideal .product").hide();	 
  $(".ideal .button").removeClass('active');
  $(this).addClass('active');
  id = $(this).prop('id');
  $('.' + id).show();	
  $('.product.' + id).first().find('input').click();	
  $('.hideform').show();
  
  
  if( $(this).attr('image').length > 0 ) {
  	 image = $(this).attr('image');
    $('.product-single__photo').addClass('hide');
    $('#FeaturedImageZoom-product-template-' + image).removeClass('hide');
  }  
  
}); 
  
 
  
$(function() {
  $("#listitems li").sort(sort_li).appendTo('#listitems');
  function sort_li(a, b) {
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
  }
});

  
$(function() {
  $("#listitems-left div.sortme").sort(sort_li).appendTo('#listitems-left');
  function sort_li(a, b) {
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
  }
});

   $(document).mouseup(function(e)  {
 	 var container = $('#account-popover');
       if (!container.is(e.target) && container.has(e.target).length === 0) { 
      	$('.header__account-icon').attr( "aria-expanded", "false" );
			$('#account-popover').attr( "aria-hidden", "true" ); 
       }	
    	 	 
   });
      
  $(".closecart").on('click', function(e) {  
    $(".closecart").hide();

  });
  
  $(".shadecart").on('click', function() {  
      $(".shadecart").hide();
      $(".closecart").hide();
      $("body").removeClass('modal-open'); 
  });
  
   $("#industry").on('change', function() {  
      location.href = '/pages/' + $( "#industry" ).val();
  });


$(".icon-state__secondary").on('click', function() {  
  $(".contentshade").hide();	 
});

$(".mobile-menu__nav-items").on('click', function() {  
  $(".contentshade").hide();	 
});

  
$(".prices.ajax.inactive").click(function(e) {
      handle = $(this).prop('id');
      $(this).addClass('curid');
      txt = "";
      $.getJSON('/products/' + handle + '.js', function(product) {
        txt = txt + "<div class='variants'>";
        $.each( product.variants, function( key, variant ) {
            txt = txt + "<div class='variant'><div class='sku'>SKU: <b>" + variant.sku + "</b></div><div class='name'>" + variant.name + "</div><div class='price' style='color:#990000;'>$" + variant.price/100 + "</div><div style='clear:both;'></div></div>";
        });
        txt = txt + "</div>";
        $('.curid').find('.details').html(txt);
        $('.curid').removeClass('curid');
        
      } );

      $(this).addClass('active').removeClass('inactive');
      $(this).parent().find('.closebut').toggle();
      $(this).parent().find('.button.prices').toggle();
      
  });  	   	  
  
  
  $(".specsection .header").click(function(e) {
    if($(this).parent().hasClass('active')) {
       $(this).parent().removeClass('active');
    } else {
  	  $(".specsection").removeClass('active');
      $(this).parent().addClass('active');
    }  
  }); 
  
  $(".closebut").click(function(e) {
      $(this).parent().find('.ajax').removeClass('active').addClass('inactive');
      $(this).parent().find('.details').html('');
      $(this).parent().find('.closebut').toggle();
      $(this).parent().find('.button.prices').toggle();
  }); 

 
  var mylang = $("html").attr("lang");
  $("."+mylang).show();
  
  $("li li.site-nav--active").parent().parent().parent().addClass('site-nav--active');
  
  
  $(".langicon").mouseover(function(e) {
      $('.languagewrapper').show();
      $('.languagewrapper').mouseenter();
  }); 
  
  $(".languagewrapper").mouseleave(function(e) {
      $('.languagewrapper').hide();
  }); 
  
  
  if ($( window ).width() >= 750) {
     $('.mobile .languagewrapper').remove();
  }
  
  $(".qty").change(function() {
   var opt = $(this).prop('id').replace('j', '');;
   $("#"+opt).val($(this).val()); 
  });
                   
  
  
if(window.location.hash.substr(1) == "recover")
{
   $("#RecoverPassword12").trigger("click")
 
}
  });
function showrest(){
 //alert("show");
  
  if($("#RecoverPasswordFormX").is(":hidden"))
 $("#RecoverPasswordFormX").show();
  else
 $("#RecoverPasswordFormX").hide();   


}
function showresthide(){
 //alert("show");
  
  
  $("#RecoverPasswordFormX").hide();


}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

async function checkAndAddVariant() {
  
  const qualifyingVariantIds = [39822211776667,41574590972059,40856192680091,40856192024731,40864522207387,40864522797211,39788104712347,43127270047899,41574590972059,39412741079195,37972471873691,18913109671995,39788045729947,40856189763739,40864633421979,40936622489755,7218957254715,15242876452923,32604472475707,20500954087483,20558099251259,41636799938715,41773204340891,36804249387163,42354463506587,34680756994203,21109487566907,12361723281467,12361418735675,34632244428955,34631802355867,34679302652059,40311934582939,19770628243515,7218996084795,39788078661787,41740737675419,40306051055771,40305800577179,36938719592603,7218998902843,42860383469723,43054160380059,39421789208731,21046607511611,35510621634715,42895621193883,20970921918523,35510118875291,35112675737755,35508783415451,21046643261499,31079050248251,33566361813051,7575711219771,34652430925979,35550849597595,35550520148123,35550470471835,35510688841883,7219006079035,7219006210107,36764061401243,39411055526043,43085729104027,33512108621883,39411658752155,35376643375259,35379450118299,18912172539963,41754532118683,20981050376251,35607327834267,39413028421787,31050515152955,34631529889947,12391850377275,35424481280155,41251351593115,19366743375931,7219037339707,38023443218587,37982851956891,37982220550299,37981330899099,37980377546907,7219038322747,39421277700251,41929625272475,41143600513179,41601437368475,43336997634203,43337178677403]; // Variants to check in the cart
  const freeVariantId = 43965226877083; // Variant to add if conditions are met
  const autoship=0;
 let totalQualifyingQuantity = 0; // Total quantity of qualifying items

  try {
    // Fetch current cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Calculate total quantity of qualifying items
    cart.items.forEach(item => {
      if (item.properties.Autoship == "Yes")
      {
     autoship=1;
      }
     
    });
    cart.items.forEach(item => {
    if (qualifyingVariantIds.includes(item.variant_id) && autoship == 0) {
        totalQualifyingQuantity += item.quantity;
      }
     
    });

    // Find the free product in the cart, if it exists
    const freeProduct = cart.items.find(item => item.variant_id === freeVariantId);
    const freeProductQuantity = freeProduct ? freeProduct.quantity : 0;
    if (!freeProduct && totalQualifyingQuantity > 0) {
      await addVariantToCart(freeVariantId, 1);
      return; // Exit function after adding one free item
    }
    // Calculate how many more free products need to be added
    const quantityToAdd = totalQualifyingQuantity - freeProductQuantity;

    if (quantityToAdd > 0) {
      // Add the necessary quantity of the free product to the cart
    //  await addVariantToCart(freeVariantId, quantityToAdd);
    } else {
      console.log('No additional free products needed.');
    }
  } catch (error) {
    console.error('Failed to check or adjust the free variant quantity:', error);
  }
}

async function addVariantToCart(variantId, quantity) {
  try {
    // Add the specified quantity of the variant to the cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      }),
    });

    if (addResponse.ok) {
      console.log(`Successfully added ${quantity} of variant ${variantId} to the cart.`);
     
     
    } else {
      console.error('Failed to add the free variant to the cart.');
    }
  } catch (error) {
    console.error('Error adding the variant to the cart:', error);
  }
}



async function addVariantToCart_Op(variantId, quantity) {
  try {
    // Add the specified quantity of the variant to the cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      }),
    });

    if (addResponse.ok) {
      console.log(`Successfully added ${quantity} of variant ${variantId} to the cart.`);
      window.location = "/checkout";
     
    } else {
      console.error('Failed to add the free variant to the cart.');
    }
  } catch (error) {
    console.error('Error adding the variant to the cart:', error);
  }
}

// custome code add by aamir ########################################
function callthis()
{
  var hazprice=0;
  var inArray=0;
  var foundthis=0;
  var ko=0;
  var ko2=0;
  // $("#hazprice").val(14000);
  //####################################################################################
  /*
   $.getJSON( "/cart.js", function( jsond ) {
    
      
      let items = jsond.items;
    
      for(var i=0; i < items.length; i++){
        
     if(items[i].id == 7218986745915 || items[i].id == 20558086930491 || items[i].id == 7218986876987 || items[i].id == 20558099251259)
      {
       ko=1; 
      }
      if(items[i].id == 7218986745915 && items[i].quantity > 1)
      {
       ko=0; 
      }

        if(items[i].id == 41785362022555 || items[i].id == 34623786287259 || items[i].id == 42897601134747 || items[i].id == 21293817036859)
      {
       ko2=1; 
      }
      if(items[i].id == 41785362022555 && items[i].quantity > 1)
      {
       ko2=0; 
      }

        
      }

     
      if(ko == 1 && ko2 == 0)
  {
   
    jQuery.post("/cart/add.js", {quantity:1,id:7218986745915});
  }

        if(ko == 0 && ko2 == 1)
  {
   
    jQuery.post("/cart/add.js", {quantity:1,id:41785362022555});
  }
    
     });
 */
 
  //###################################################################################
  const getCookieVal = name => document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))?.at(2);
  const cookie_acdc = getCookieVal("acdc");
  if(cookie_acdc == getCookieVal("cart") + '~' + 'ISOHAZMAT4P')
  {
    var APIURL = "https://agb.aae.mybluehost.me/agb.aae.mybluehost.me/shipping/shopify_ajax-discount.php"
  } else {
    var APIURL = "https://dashboard.laballey.com/shopify_ajax.php"
  }
   $.getJSON( "/cart.js", function( json ) {
     
  $.post(APIURL,{ json:json }, function (data) {
      
   var re = data.split('|');
   var c=0;
       
       //hazprice
     hazprice=re[12];

//##### restricted chmincal messages ##################3    
  if(re[11] == 1 || re[11] == "1")
   $("#b_mess").show();
   
   if(re[9] == 1 || re[9] == "1")
   $("#rs_mess").show();
// ###### end restricted message #########################  
       
   if(re[16] > 0)
   {
    jQuery.ajax({
  type: "POST",
  url: "/cart/update.js",
  data: {
    updates: {
      "39788177916059":re[16], // Variant ID 1: Quantity
      "39788177850523":re[16]  // Variant ID 2: Quantity, etc.
    }
  },
  dataType: "json",
  success: function(response) {
    // Handle success (e.g., notify the user, update cart UI)
    console.log("Cart updated:", response);
  },
  error: function(xhr, status, error) {
    // Handle error
    console.log("Error updating cart:", error);
  }
});
     c=1;
   }
    else {
      //#### adding Hazmet
   if(re[0] == 1 || re[0] == "1")
   {
// #### if not multi hazmet ##############################

   
     
     if(re[5] == 0) // if not multi hazmet
     {
     
     jQuery.post("/cart/add.js", {
  quantity:1,id:39788177916059
});

     }
     else // if multi hazmet
     {
       if(re[8] < 0)
       {
       jQuery.post("/cart/update.js", "updates[39788177916059]="+re[6]);
         
       }
       if(re[8] == 0)
       {
       jQuery.post("/cart/add.js", {
  quantity:re[6],id:39788177916059
});
       }
      if(re[8] > 0)
       {
       jQuery.post("/cart/add.js", {
  quantity:re[8],id:39788177916059
});  
       }
         
     //  alert("add"+re[6] );
       
     }
  c=1;   
   }
   // end adding hazmet

    
   //#### adding poison
   if(re[1] == 1 || re[1] == "1")
   {
     
     jQuery.post("/cart/add.js", {
  quantity:1,id:39788177850523
});
     c=1;
   
   }
// id pos i smulti
    if(re[13] == 1 || re[13] == "1")
   {
  jQuery.post("/cart/update.js", "updates[39788177850523]="+re[14]);
    
   }
// end multi pos    
    
   // end adding pos
// removing carts item
   if(re[2] == 1 || re[2] == "1")
   {
  jQuery.post("/cart/update.js", "updates[39788177916059]="+ re[4] +"");
  c=1;
    
   }
   if(re[3] == 1 || re[3] == "1")
   {
    jQuery.post("/cart/update.js", "updates[39788177850523]=0");
    
    c=1;
   }
    }

   
   
  // end rmeoving if not apply
   if(c == 1)
   {
  sleepFor(1000);
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      quantity: 1
    }
  })); 
     
    
   }
  
  
});// dashboard post
 });// end get cart js
   
 //alert(hazprice);
} // end call this function

function sleepFor(sleepDuration){
    var now = new Date().getTime();
    while(new Date().getTime() < now + sleepDuration){ 
       
    }
}

(function(ns, fetch) {
    if (typeof fetch !== 'function') return;

    ns.fetch = function() {
        const response = fetch.apply(this, arguments);

        response.then(res => {
            if ([
                    
                     `${window.location.origin}/cart/change.js`,
                     `${window.location.origin}/cart/add.js`,
                      `${window.location.origin}/cart/update.js`
                    
                ].includes(res.url)) {
           
           callthis();
           remove_att();   
              
            }
        });

        return response;
    }

}(window, window.fetch))

    

              







